// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback} from 'react';
import etask from '/util/etask.js';
import {toggle_bvpn_ref, set_multiplier} from '@pub/store/user.js';
import {Text} from '@pub/comp/text';
import {Text_input} from '@pub/comp/text_input';
import {Button} from '@pub/comp/button';
import {Checkbox} from '@pub/comp/checkbox';
import {alert} from '@pub/comp/alert';
import * as cns from './editing.module.less';

const with_alert = (task, pos_msg)=>etask(function*(){
    try {
        yield task;
        alert({
            title: 'User has been updated',
            text: pos_msg,
            positive: true,
        });
    } catch(e){
        alert({title: 'Failed to update', negative: true});
    }
});

function Bvpn_toggler({user}){
    const handle_change = useCallback(value=>with_alert(toggle_bvpn_ref(value),
        'Bright VPN link status changed'), []);
    return <div>
      <Text.m>Bright VPN referral link</Text.m>
      <Checkbox checked={user.bvpn_ref_enabled} on_change={handle_change}
        label="Enabled"/>
    </div>;
}

function Mult_setter({user}){
    const [mult, set_mult] = useState(user.multiplier||1);
    const handle_apply = useCallback(()=>with_alert(set_multiplier(mult),
        'The earnings multiplier successfully updated'), [mult]);
    const disabled = mult==user.multiplier || mult<0;
    return <div>
      <Text.m>Earnings multiplier</Text.m>
      <div className={cns.row}>
        <Text_input placeholder="Earnings multiplier"
          value={mult} on_change={set_mult} on_enter={handle_apply}
          size="s"/>
        <Button on_click={handle_apply}
          disabled={disabled} size="s" color_scheme="primary" filled>
          Apply
        </Button>
      </div>
    </div>;
}

export function Editing({user}){
    return <div className={cns.root}>
      <Bvpn_toggler user={user}/>
      <Mult_setter user={user}/>
    </div>;
}
